export enum AppPaths {
	LOGIN = 'login',
	RESET_PASSWORD = 'reset-password',
	SET_PASSWORD = 'set-password',

	PRODUCT_TYPES = 'product-types',
	PRODUCTS = 'products',
	ACCESSORIES = 'accessories',
	FABRIC_CATEGORIES = 'fabric-categories',
	FABRICS = 'fabrics',

	ORDERS = 'orders',
	PRODUCTION = 'production',

	ADMINS = 'admins',
	USERS = 'users',

	ATTRIBUTES = 'attributes',
	ATTRIBUTE_VALUES = 'attribute-values',

	ROLES = 'roles',
	CONTENT = 'content',
	DOWNLOADABLE_FILES = 'downloadable-files',
}
